import Resource from '@/plugins/sdk/Resource'
import { BOOLEAN, DATETIME, UUID, ITEM } from '@/plugins/sdk/fields'
import Account from '@/plugins/sdk/resources/Account'
import RateSurcharge from '@/plugins/sdk/resources/RateSurcharge'

export default class extends Resource {
  static name = 'invoicesurcharge'

  static get fields () {
    return {
      id: new UUID(),
      deleted: new BOOLEAN(),
      deleted_date: new DATETIME(),
      account: new ITEM(Account),
      rate_surcharge: new ITEM(RateSurcharge)
    }
  }
}
